import { useField } from "formik";

const TextInput = (props) => {
  const { label, name, placeholder, onChangeHandler, type } = props;
  const [field, meta] = useField(name);
  const configTextfield = {
    ...field,
    error: false,
    value: field.value,
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  function clsAlphaNoOnly(e) {
    if (type !== "number") {
      const regEx1 = /[^a-zA-Z-ğüşöçıIİĞÜŞÖÇ\s]+/;
      e.target.value = e.target.value.replace(regEx1, "");
      field.onChange(e);
    }

    if (onChangeHandler) {
      onChangeHandler(e.target.value);
    }
    field.onChange(e);
  }
  return (
    <div
      className={
        meta && meta.touched && meta.error
          ? "form-input error-form"
          : "form-input"
      }
    >
      <label htmlFor={name}>{label}</label>
      <input
        placeholder={placeholder}
        type="text"
        name={name}
        value={field.value}
        onChange={(event) => clsAlphaNoOnly(event)}
        className={
          meta && meta.touched && meta.error
            ? "error form-control"
            : "form-control"
        }
      />
      {meta && meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default TextInput;
